import "core-js/modules/es6.object.keys.js";
export var combineInvalidationPolicies = function combineInvalidationPolicies(invalidationPoliciesConfigs) {
  var invalidationPolicies = {};
  invalidationPoliciesConfigs.forEach(function (policyConfig) {
    Object.keys(policyConfig).forEach(function (typename) {
      var invalidationPolicy = policyConfig[typename];
      if (!invalidationPolicies[typename]) {
        invalidationPolicies[typename] = {};
      }
      var existingInvalidationPolicy = invalidationPolicies[typename];
      Object.keys(invalidationPolicy).forEach(function (invalidationPolicyKey) {
        if (existingInvalidationPolicy[invalidationPolicyKey]) {
          throw new Error("Merge conflict combining invalidation policies key ".concat(invalidationPolicyKey, " for typename ").concat(typename, ". Please resolve this conflict by providing only one value of ").concat(invalidationPolicyKey, "."));
        }
        existingInvalidationPolicy[invalidationPolicyKey] = invalidationPolicy[invalidationPolicyKey];
      });
    });
  });
  return invalidationPolicies;
};